/**
 * The case area's three routes, aggregated.
 *
 * The file is `.routes.tsx` (plural) because it exports an ARRAY — the importer
 * knows the shape from the name, which is what the naming rule exists for. Each
 * page keeps its own singular `*.route.tsx`; this file only collects them so
 * `src/router/routes.ts` gains one line per area rather than one per page.
 *
 * **Order is load-bearing here.** `cases/new` and `cases/:id` are both one
 * segment past `cases`, and React Router ranks a literal segment above a
 * dynamic one — but the order is written the safe way regardless, so the raise
 * form's URL can never be read as a case whose id is `new`.
 */
import type { RouteObject } from 'react-router-dom';

import { caseDetailRoute } from './detail/detail.route';
import { newCaseRoute } from './new/new.route';
import { caseQueueRoute } from './queue/queue.route';

export const caseRoutes: RouteObject[] = [caseQueueRoute, newCaseRoute, caseDetailRoute];
